export const accountFilters = {
  ALL: 'All',
  ASSIGNED: 'Assigned',
  UNASSIGNED: 'Unassigned',
};
